/** @jsx jsx */
import React, { Fragment as _, useState, useEffect, useContext } from 'react';
import { css, jsx } from '@emotion/core';
import variables from '../variables';
import YourImagePreviewPanel from './YourImagePreviewPanel';
import Search from '../Search';
import YourImagePreview from './YourImagePreview';
import { useQuery } from 'urql';
import gql from 'graphql-tag';
import PrevNextPage from '../PrevNextPage';
import { ImageLibraryContext } from '../../EditImage';
import { useSelector } from 'react-redux';
import { State } from 'store/store';

const { thumbnailsContainerHeight } = variables;
const URL_PREFIX = window['chameleon'].CHAMELEON_URL;

//
const uploadsQuery = gql`
  query pgqlUploads(
    $accountId: ID!
    $slug: ID!
    $filter: String
    $per: Int
    $page: Int
  ) {
    organization(accountId: $accountId) {
      data {
        project(slug: $slug) {
          data {
            name
            uploads(filter: $filter, per: $per, page: $page) {
              data {
                id
                name
                url
                size
              }
              meta {
                totalCount
                totalPages
                currentPage
                perPage
              }
            }
          }
        }
      }
    }
  }
`;

let moduleImages: any[] = [];

const YourLibrary = () => {
  const {
    currentImageSrc,
    currentImageId,
    cacheSelected,
    cacheFilter,
  } = useContext(ImageLibraryContext)!;
  const [filter, setFilter] = useState(cacheFilter!.value);
  const [page, setPage] = useState(1);
  const [per] = useState(25);
  const { projectId } = useSelector((state: State) => {
    return {
      projectId: state.projectId,
    };
  });

  const urlParams = new URL(window?.top?.location?.href || '');
  const path = urlParams?.pathname;
  const pathSplit = path
    .split(/\//g)
    .filter((entry: string) => entry && entry !== 'edit');
  const accountId = pathSplit[0] || '';
  const slug = pathSplit[1] || '';

  const [res, reload] = useQuery({
    query: uploadsQuery,
    variables: {
      accountId,
      slug,
      filter,
      page,
      per,
    },
    requestPolicy: 'cache-and-network',
  });
  let meta: any = {};

  if (res && res?.data) {
    const uploads = res?.data?.organization?.data?.project?.data?.uploads || {};

    moduleImages = [
      ...uploads?.data.map((entry: any) => ({
        ...entry,
        url: `${URL_PREFIX}${entry.url}`,
      })),
    ];
    meta = uploads?.meta;
  }
  const isMore = meta.totalCount && per < meta.totalCount;
  const [selected, setSelected] = useState(cacheSelected!.yourLibrary);

  // load the currently ' selected ' image by its id
  useEffect(() => {
    if (filter) {
      return;
    }
    if (!cacheSelected!.yourLibrary) {
      const existingImageData = moduleImages.find((entry: any) => {
        //
        return entry.id === currentImageId;
      });
      existingImageData &&
        setSelected((cacheSelected!.yourLibrary = existingImageData));
    }
  }, [moduleImages.length]);
  useEffect(() => {
    if (!filter) {
      return;
    }
    !cacheSelected!.yourLibrary &&
      setSelected((cacheSelected!.yourLibrary = moduleImages[0]));
  }, [filter, moduleImages.length]);
  return (
    <div
      css={css`
        position: relative;
        display: flex;
        width: 100%;
        height: 100%;
      `}
    >
      <div
        css={css`
          flex: 1;
          padding: 0 5px 0 0;
        `}
      >
        {/* <UploadImg /> */}
        <YourImagePreviewPanel
          preview={selected}
          onUploadImage={(result, e) => {
            setSelected((cacheSelected!.yourLibrary = result));
            reload();
          }}
        />
      </div>
      <div
        css={css`
          position: relative;
          flex: 2;
          // padding: 10px 20px ${isMore ? 40 : 10}px 20px;
          padding: 10px 20px 40px 20px;
          background: #eaefff;
        `}
      >
        <Search
          defaultValue={cacheFilter!.value}
          onSearch={value => {
            // setPage(1);
            setFilter((cacheFilter!.value = value));
            // unset. .
            setSelected((cacheSelected!.yourLibrary = null));
            // reload();
          }}
        />
        <div
          css={css`
            position: relative;
            height: ${thumbnailsContainerHeight()};
            overflow-y: auto;
          `}
        >
          <div
            css={css`
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              display: grid;
              grid-template-columns: repeat(auto-fill, minmax(155px, 1fr));
            `}
          >
            {moduleImages.map((entry, i) => {
              //
              const { id, name, url } = entry;
              return (
                <YourImagePreview
                  key={`${name}${i}`}
                  data={{
                    ...entry,
                    url,
                  }}
                  selected={selected}
                  setSelected={() => {
                    setSelected(
                      (cacheSelected!.yourLibrary = {
                        ...entry,
                        url,
                      })
                    );
                  }}
                />
              );
            })}
          </div>
        </div>
        <PrevNextPage
          page={page}
          totalPages={meta.totalPages}
          updatePage={dir => {
            setPage(page => {
              return (dir === 'prev'
                ? page > 1 && page - 1
                : page < meta.totalPages && page + 1) as number;
            });
          }}
        />
        {/* {isMore && <LoadMore setPer={setPer} />} */}
      </div>
    </div>
  );
};
export default YourLibrary;
